import { CALCULATIONS_CONFIG } from './calculations';
import { Aggregations, aggregationsSchema } from './schema';

// Aggregations are used specifically in table panel and table legend.

export const AGGREGATIONS_CONFIG = aggregationsSchema.options.reduce(
  (config, value) => {
    config[value] = CALCULATIONS_CONFIG[value];

    return config;
  },
  {} as Partial<Record<Aggregations, { label: string; description?: string }>>
);

export type AggregationOption = { id: Aggregations; label: string; description?: string };

/**
 * Used to populate the options in the SettingsAutocompleteOption component
 */
export const AGGREGATION_OPTIONS: AggregationOption[] = Object.entries(AGGREGATIONS_CONFIG).map(([id, config]) => {
  return {
    id: id as Aggregations,
    ...config,
  };
});
